/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Muddy_Glad_Stingray_DineInputs */

const fr_muddy_glad_stingray_dine = /** @type {(inputs: Muddy_Glad_Stingray_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateur supprimé avec succès`)
};

/**

* @param {Muddy_Glad_Stingray_DineInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const muddy_glad_stingray_dine = /** @type {((inputs?: Muddy_Glad_Stingray_DineInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Muddy_Glad_Stingray_DineInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_muddy_glad_stingray_dine(inputs)
});